/*
 Popup based on http://getbootstrap.com/javascript/#popovers plugin
 You can upgrade Popup options based on http://getbootstrap.com/javascript/#tooltips options table
 */

bq.popup = function (element, options) {
    this.options  = options;
    this.$element = $(element);
};

bq.popup.DEFAULTS = {
    container:       'body'
    , content:       ''
    , contentTarget: null
    , placement:     'right auto'
    , trigger:       'click'
};

bq.popup.prototype = {
    init: function () {
        bq.debug.log("popup : init()", this.$element);

        // bypass if mobile
        if (bq.helper.mq.is('xs')) {
            return;
        }

        // check if content target to DOM element
        if (this.options.contentTarget != null) {
            this.options.content = $(this.options.contentTarget).first().html();
            this.options.html    = true; // make "true" because insert content as HTML into the popup
        }

        this._createPopup();
    },

    _createPopup: function () {

        // Safari 7+ fix
        // This fix can be deleted after update Bootstrap Tooltip and Popover plugin to version 3.3.6+
        if( !this.$element.attr('tabindex') ) {
            this.$element.attr('tabindex', 0)
        }

        // Default hover trigger doesn't allow to hover on popup, because of that the "manual-hover" trigger was implemented
        if (this.options.trigger === 'manual-hover') {
	        this.$element.popover(this.options).on('mouseenter', function () {
		        var _this = this;
		        var popoverBlock = $('.popover');
		        var showPopup = true;
                var specificPopoverBlock = $(this).data('content-block-specific') ? $(this).data('content-block-specific') : false;

                if (showPopup) {
				    $(_this).popover('show');
                }

		        if (specificPopoverBlock) {
		        	$(specificPopoverBlock).each(function() {
		        		if ($(this).closest('.popover').length) {
					        popoverBlock = $(this).closest('.popover');
				        }
			        });
		        }

		        if (popoverBlock.is(':visible')) {
			        if (specificPopoverBlock && popoverBlock.find(specificPopoverBlock).length) {
				        showPopup = false;
			        }
		        }

		        popoverBlock.on('mouseleave', function () {
			        setTimeout(function () {
				        if (!$(_this).is(':hover')) {
					        $(_this).popover('hide');
				        }
			        }, 150);
		        });
	        }).on('mouseleave', function () {
		        var _this = this;

		        setTimeout(function () {
			        if (!$('.popover:hover').length) {
				        $(_this).popover('hide');
			        }
		        }, 150);
	        });
        } else {
          var $element = this.$element;
          $element
		        .on('click', function(e){
			        e.preventDefault();
		        })
		        .popover(this.options);

          $element.on('shown.bs.popover', function () {
            $element.removeClass('popover-click-hidden').addClass('popover-click-open');
          });

          $element.on('hidden.bs.popover', function () {
            $element.removeClass('popover-click-open').addClass('popover-click-hidden');
          });
        }
    }
};


// popup PLUGIN DEFINITION
// =======================

var popupOld = $.fn.popup;

$.fn.popup = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.popup');
        var options = $.extend({}, bq.popup.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) {
            $this.data('bq.popup', (data = new bq.popup(this, options)));
        }
        data.init();
    });
};

$.fn.popup.Constructor = bq.popup;

// popup NO CONFLICT
// =================

$.fn.popup.noConflict = function () {
    $.fn.popup = popupOld;
    return this;
};

// FORM FILL DATA-API
// ==============

bq.popupInit = function () {
    /* postponed initialization, content might be loaded over ajax */
    $('[data-bq="popup"]:not(.observable)').addClass('observable').each(function(){
      var el = $(this);

      if (bq.helper.mq.is('xs') || $('html').hasClass('touch')) {
        bq.global.percentageKnob();
        var contentTarget = el.data('content-target');
        var html = $(contentTarget).html();

        el.data({
          'html': true,
          'content': html,
          'trigger': 'click',
          'init': true
        });

        el.on('click', function(e){
          e.preventDefault();
        });

        el.popover(el.data());
        return;
      }

      if (el.attr('data-content-html')) {
        el.data({
          'html': true,
          'content': el.attr('data-content-html'),
          'trigger': el.attr('data-trigger'),
          'init': true
        });

        el.popover(el.data());
        return;
      }

      if (el.attr('data-trigger') === 'manual-hover') {
          setTimeout(function(){

            el.popup(el.data());
          }, 1000);

          el.mouseover(function () {
            if (el.data('bq.popup')) {
              return;
            }
          });

          return;
        }

      el.popup(el.data());
    });

    $('[data-bq="popup-static"]').each(function () {
        var el = $(this);
        var contentTarget = el.data('content-target');
        var html = el.closest(contentTarget).html();
        el.data({
            'html': true,
            'template': html
        });
        el.popover(el.data());
    });

    $('[data-bq="popup-original-title"]').each(function () {
       var el = $(this);
       var trigger = bq.helper.mq.is('xs') ? 'click' : 'hover focus';
       el.data({
         'content': el.text() || el.data('original-content'),
         'trigger': trigger,
         'placement': 'top auto'
       });
	    el.popover(el.data());
    });
};

if (bq.helper.mq.is('xs')) {
  $('body').on('click', function (e) {
    if ($(e.target).data('bq') !== 'popup-original-title'
      && $(e.target).parents('.popover.in').length === 0) {
      $('[data-bq="popup-original-title"]').popover('hide');
    }
  });
} else if (bq.helper.mq.is('sm')) {
  $('body').on('click', function (e) {
    if ($(e.target).closest('.popover-click-open').length > 0 || $('.popover:visible').length <= 0) return;

    if ($(e.target).closest('.popover').length <= 0) {
      $('.popover-click-open').popover('hide');
    }
  });
}

bq.init.push(bq.popupInit);
